import { atom } from 'jotai'
export const homeAtom = atom(false);